// frontend/src/components/EmpresaPortal/EmpresaSidebar.js
//
// Menú de navegación lateral del portal de empresa. Por ahora solo
// "Dashboard" y "Usuarios" tienen contenido propio; el resto de las secciones son enlaces
// de cara a futuro (ver EmpresaPortal.js: vistasConContenido).

import React from 'react';
import { Home, Users, FileText, Layers, BarChart3, Settings, UserCog, ChevronsLeft, ChevronsRight } from 'lucide-react';
import './EmpresaSidebar.css';

const ITEMS = [
  { key: 'dashboard', label: 'Dashboard', icon: Home },
  { key: 'candidatos', label: 'Candidatos', icon: Users },
  { key: 'evaluaciones', label: 'Evaluaciones', icon: FileText },
  { key: 'stacks', label: 'Mis stacks', icon: Layers },
  { key: 'resultados', label: 'Resultados', icon: BarChart3 },
  { key: 'usuarios', label: 'Usuarios', icon: UserCog },
  { key: 'configuracion', label: 'Configuración', icon: Settings }
];

const EmpresaSidebar = ({ vista, onNavegar, colapsado, onToggle }) => {
  return (
    <aside className={`ep-sidebar ${colapsado ? 'ep-sidebar-colapsado' : ''}`} data-tour="sidebar">
      <nav className="ep-sidebar-nav">
        {ITEMS.map(({ key, label, icon: Icon }) => (
          <button
            key={key}
            type="button"
            className={`ep-sidebar-item ${vista === key ? 'active' : ''}`}
            onClick={() => onNavegar(key)}
            title={colapsado ? label : undefined}
          >
            <Icon size={18} />
            <span>{label}</span>
          </button>
        ))}
      </nav>
      <button
        type="button"
        className="ep-sidebar-toggle"
        onClick={onToggle}
        title={colapsado ? 'Expandir menú' : 'Ocultar menú'}
      >
        {colapsado ? <ChevronsRight size={16} /> : <ChevronsLeft size={16} />}
        <span>Ocultar menú</span>
      </button>
    </aside>
  );
};

export default EmpresaSidebar;
